import { useContext } from 'react';
import BacksolveContext from 'context/BacksolveContext';
import CaptableSecurities from 'pages/Allocation/allocations/components/backsolve-ledger/CaptableSecurities';

const SecurityGridSelect = (props: any) => {
  const { securityList } = useContext(BacksolveContext);
  return <CaptableSecurities menuPosition="absolute" securityList={securityList} {...props} />;
};

export default SecurityGridSelect;
